import React from 'react';
import { X } from 'lucide-react';
import Logo from '../Logo';

interface ActivityHeaderProps {
  activityTitle: string;
  timeLeft: number;
  onClose: () => void;
}

export function ActivityHeader({ activityTitle, timeLeft, onClose }: ActivityHeaderProps) {
  return (
    <div className="bg-gradient-to-r from-cyan-500 to-blue-600 px-6 py-4 text-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Logo size="lg" variant="icon-only" />
          <div>
            <h2 className="text-xl font-bold font-baloo">{activityTitle}</h2>
            <p className="text-cyan-100">Focus Activity with Neuro</p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <div className="text-right">
            <div className="text-2xl font-bold font-baloo">
              {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
            </div>
            <div className="text-xs text-cyan-100">Time Left</div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
}
